const actions = {
    SAVE_DRAFT: 'SAVE_DRAFT',
    FETCH_DRAFTS: 'FETCH_DRAFTS',
    FETCH_DRAFT_BY_ID: 'FETCH_DRAFT_BY_ID',
    DELETE_DRAFT: 'DELETE_DRAFT',
    DISCARD_DRAFT_ATTACHMENT: 'DISCARD_DRAFT_ATTACHMENT',
    RESET_DRAFT_FORM: 'RESET_DRAFT_FORM',

    saveDraftAction: (data) => {
        return {
            type: actions.SAVE_DRAFT,
            data: data
        };
    },
    fetchDraftsAction: (data) => {
        return {
            type: actions.FETCH_DRAFTS,
            data: data
        };
    },
    fetchDraftByIdAction: (data) => {
        return {
            type: actions.FETCH_DRAFT_BY_ID,
            data: data
        };
    },
    deleteDraftAction: (id) => {
        return {
            type: actions.DELETE_DRAFT,
            data: id
        };
    },
    discardDraftAttachmentAction: (payload) => {
        return {
            type: actions.DISCARD_DRAFT_ATTACHMENT,
            data: payload
        };
    },
    resetDraftFormAction: () => {
        return {
            type: actions.RESET_DRAFT_FORM,
            data: null
        };
    }
};

export default actions;